module.exports = __webpack_public_path__ + "img/gg_check-o.c51e7cec.svg";